export default __webpack_public_path__ + "static/media/login.8f6b76c8.png";